import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const URL_DEMANDAS = `${modulo.GESTAO_DE_DEMANDAS}`

const actions = {
  async save ({ commit }, { demanda, idPainel }) {
    return axios({
      method: 'post',
      loaderText: 'Carregando ...',
      data: demanda,
      url: `${URL_DEMANDAS}?idPainel=${idPainel}`,
      error: true
    })
  },

  findById ({ commit }, id) {
    return axios({
      method: 'get',
      loaderText: 'Carregando ...',
      url: `${URL_DEMANDAS}?id=${id}`
    })
  },

  async findByFilter ({ commit }, filtro) {
    const data = await axios({
      method: 'post',
      loaderText: 'Carregando ...',
      url: `${URL_DEMANDAS}/findByFilter`,
      data: filtro
    })
    return data
  },

  async findAllByFilter ({ commit }, filtro) {
    const data = await axios({
      method: 'post',
      loaderText: 'Carregando ...',
      url: `${URL_DEMANDAS}/findAllByFilter`,
      data: filtro
    })
    return data
  },

  delete ({ commit }, id) {
    return axios({
      method: 'delete',
      loaderText: 'Carregando ...',
      url: `${URL_DEMANDAS}?id=${id}`
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/demandas/demandas.js